import { Block, BlockSchema } from './Block.types';

import { HeroBlockConfigSchema, BlockType } from './blockConfig/Types';

import { z } from 'zod';

export const HeroBlockSchema = BlockSchema.extend({
  blockConfig: HeroBlockConfigSchema,
});

export type HeroBlock = z.infer<typeof HeroBlockSchema>;

export function isHeroBlock(block: Block): block is HeroBlock {
  return block.blockConfig.type === BlockType.Hero;
}
